// extracted by mini-css-extract-plugin
export var editInput = "_ib-0";
export var editInputCompact = "_ib-2";
export var editInputLarge = "_ib-1";
export var editInputSmall = "_ib-3";